import React from 'react'
import { useEffect, useState, useRef, createRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryBase from "../components/EntryBase";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata,
    getformid, getcontroller, getsubkey, initializedata, isEnabled, DicVal, NumConv
} from '../modules/appLibrary';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, entrytriggercall, setgridlist } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup } from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const InvExpense = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", NB: "nb", PL: "pl", TOTAL: "T1" };
    // 合計対象と格納先
    const TOTAL_TARGET_FIELD = "IKDM_KINGAKU";  // 明細側の集計対象カラム
    const TOTAL_STORE_FIELD = "IKD_ENTOTAL";    // 合計行の格納先カラム
    // Invoice区分(輸出入区分) によるパネル出し分け
    const INV_KBN_FIELD = "IVD_YUSHUTUNYUKBN";
    const PANEL_TYPES_BY_KBN = {
        "1": ["100", "101", "102", "103"],  // 輸入
        "2": ["110", "111", "112", "113"]   // 輸出
    };
    const formid = getformid("InvExpense", props.location.search);
    const controller = getcontroller("InvExpense", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const formListOption = useSelector(state => state.form.listoption);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);

    const formstatus = useSelector(state => state.form.status);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const gridlist = useSelector(state => state.form.gridlist);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    const yunyuyushutuKbn = useRef("1");

    const entrydataRef = useRef(null);

    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
    function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    const actionurl = {
        "update": "Forms/Update",
        "delete": "InvExpense/Delete",
        "getlist": "InvExpense/GetListData",
    }

    const suppressaction = [
        { type: "1", action: "INSERT" },
        { type: "1", action: "UPDATE" },
        { type: "2", action: "INSERT" },
        { type: "2", action: "UPDATE" },
    ];

    const navmenu = [
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }

    // 主キー: IKD_INVOICEKANRINO + IKD_INVOICEKANRIEDA を "_" で連結
    const primarykeys = ["IKD_INVOICEKANRINO", "IKD_INVOICEKANRIEDA"];
    function primarykey() {
        return "IKD_KEY";
    }
    function buildIkdKey(data) {
        if (isEmpty(data)) return "";
        return primarykeys.map(k => DicVal(data, k, "")).join("_");
    }

    function keepListOptionValue(target, source) {
        if (isEmpty(target)) return target;
        if (isEmpty(formListOption) || formListOption.length === 0) return target;

        let newdata = { ...target };
        formListOption.forEach(option => {
            if (isEmpty(option.columnid)) return;
            if (!isEmpty(source) && source[option.columnid] !== undefined) {
                newdata[option.columnid] = source[option.columnid];
            }
        });
        return newdata;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    fnc.current.initMaster(data.master);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        idx++;
                        let t = data.colinfo.find(e => e.logpid === "T" + panel.id);
                        if (!isEmpty(t)) {
                            gridapiRefs.current[idx] = createRef();
                            gridcolapiRefs.current[idx] = createRef();
                            griddataRefs.current[idx] = createRef();
                            gridcolRefs.current[idx] = createRef();
                            glist.push({ id: "T" + panel.id, type: t.type, index: idx });
                            idx++;
                        }
                    });

                    dispatch(setgridlist(glist));

                    if (data.prelayout) {
                        RestoreLayout(data.panels, fields);
                    }

                    let state = props.location.state;
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
                }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1);
    }, [menuinfo]);

    useEffect(() => {
        if (formstatus !== "COPY FORM" || isEmpty(columninfo)) return;
        columninfo.filter(e => e.copyclear).forEach(function (col) {
            entrydataRef.current[col.columnid] = "";
        });
        rerender();
    }, [formstatus, columninfo]);

    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code);
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;
    }
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            if (call) callshow();
        }
    }
    function Show(data, pushcode, option) {
        let code = "";
        yunyuyushutuKbn.current = String(option);
        if (data === undefined) {
            if (!isEmpty(pushcode)) {
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;
            }
        } else {
            setglobaldata("entryrowdata", data);
            if (data !== null) {
                // まず IKD_KEY を優先、なければ primarykeys から組み立て
                if (!isEmpty(data["IKD_KEY"])) {
                    code = data["IKD_KEY"];
                } else {
                    code = buildIkdKey(data);
                }
            }
            setedittingcode(code);
        }

        if (isEmpty(columninfo)) return false;

        clearform(code === "");
        // NEW FORM の場合はリストオプション(輸出入区分ラジオ)を反映
        if (code === "" && !isEmpty(entrydataRef.current) && !isEmpty(option)
            && PANEL_TYPES_BY_KBN[String(option)]) {
            entrydataRef.current[INV_KBN_FIELD] = String(option);
        }
        LoadData(code);
        return true;
    }

    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e => e.type !== type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
    }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function MenuAction(action, finallycallback) {
        LayoutSaveStorage();
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type) ? true : e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid, col.type);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid, type: col.type }));
        }
    }
    function Save(finallycallback, nocheck) {
        storeRowData();
        SetPLData();
        if (!isEmpty(entrydataRef.current)) {
            //entrydataRef.current["IKD_KEY"] = buildIkdKey(entrydataRef.current);
            entrydataRef.current = {
                ...entrydataRef.current,
                IKD_KEY: buildIkdKey(entrydataRef.current)
            };
        }
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData({ id: gridlist[i].id, type: gridlist[i].type });
        }
        const paramdata = {
            "controller": controller,
            "data": entrydataRef.current,
            "detail": detail,
            "colinfo": columninfo,
            "code": edittingcode,
            "noconfirm": nocheck
        }
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "InvExpense/UpdateEntry" : "InvExpense/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if (pkey !== "") entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        fnc.current.success();
                        if (formstatus === "ENTRY FORM") {
                            data.data['rowid'] = Getrowid();
                            finallycallback(data.data);
                        }
                        LoadData(code);
                    }
                    else {
                        if (isEnabled(data.confirm)) {
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください", "　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("InvExpense/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        let pkey = primarykey();
                        finallycallback(edittingcode, pkey === "" ? [] : [pkey]);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    function LoadData(code) {
        if (code === "") return;

        const yunyuYushutu = {
            "IVD_YUNYUYUSHUTUKBN": yunyuyushutuKbn.current
        }
        const paramdata = {
            data: yunyuYushutu
        }

        fnc.current.postaxios('InvExpense/GetData', { "code": code, "data": paramdata, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            const beforeData = entrydataRef.current;

                            fnc.current.margeMaster(data.master);

                            entrydataRef.current = keepListOptionValue(data.data, beforeData);

                            // 明細/合計ペアの控え(輸入=1/T1, 輸出=2/T2 等 複数対応)
                            const detailForTotalList = [];
                            for (let i = 0; i < gridlist.length; i++) {
                                const detailRows = data.detail[gridlist[i].type];
                                if (Array.isArray(detailRows) ? detailRows.length !== 0 : !isEmpty(detailRows)) {
                                    SetGridData({ id: gridlist[i].id, type: gridlist[i].type }, detailRows);
                                }
                                if (gridlist[i].id.substr(0, 1) !== "T" && gridlist[i].id !== G_id.PL &&
                                    gridlist.some(e => e.id === "T" + gridlist[i].id)) {
                                    detailForTotalList.push({ id: gridlist[i].id, rows: detailRows });
                                }
                            }
                            // 各明細ペアごとに合計行データをセット
                            detailForTotalList.forEach(function (item) {
                                const totalValue = TotalCalc(item.rows);
                                SetGridData({ id: "T" + item.id }, [{
                                    rowid: "TOTAL",
                                    grip: "計",
                                    [TOTAL_STORE_FIELD]: totalValue
                                }]);
                            });
                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            rerender();

                            dispatch(changestatus("ENTRY FORM"));
                        }
                        fnc.current.wait(false);
                    } catch (error) {
                        fnc.current.wait(false);
                    }
                },
                onError: function (data) {
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                    fnc.current.wait(false);
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    function clearform(newform) {
        const beforeData = entrydataRef.current;

        entrydataRef.current = keepListOptionValue(initializedata(textfieldsall, staff), beforeData);
        // Invoice区分の初期値を輸入(=1)にセット
        if (!isEmpty(entrydataRef.current) && isEmpty(DicVal(entrydataRef.current, INV_KBN_FIELD, ""))) {
            entrydataRef.current[INV_KBN_FIELD] = yunyuyushutuKbn.current;
        }
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }
        entrydataRef.current[INV_KBN_FIELD] = yunyuyushutuKbn.current;

        fnc.current.modify(false);

        if (isEnabled(newform)) {
            const fieldList = textfieldsall.filter(item =>
                PANEL_TYPES_BY_KBN["1"].includes(item.type)
            );
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: fieldList },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = keepListOptionValue(initializedata(fieldList, staff), beforeData);
                        entrydataRef.current[INV_KBN_FIELD] = yunyuyushutuKbn.current;
                        if (!isEmpty(entrydataRef.current) && isEmpty(DicVal(entrydataRef.current, INV_KBN_FIELD, ""))) {
                            entrydataRef.current[INV_KBN_FIELD] = "1";
                        }
                        rerender();
                    },
                }, true
            )
        }
    }

    function ValueChanged(id, value, edit) {
        // Invoice管理No.、(枝番)入力時
        if ((id === "IKD_INVOICEKANRINO" || id === "IKD_INVOICEKANRIEDA") && edit) {
            if (isEmpty(value)) {
                return;
            }
            var values = [];
            switch (id) {
                case "IKD_INVOICEKANRINO":
                    values.push(value);
                    values.push(entrydataRef.current["IKD_INVOICEKANRIEDA"]);
                    values.push(entrydataRef.current["IVD_YUSHUTUNYUKBN"]);
                    break;
                case "IKD_INVOICEKANRIEDA":
                    values.push(entrydataRef.current["IKD_INVOICEKANRINO"]);
                    values.push(value);
                    values.push(entrydataRef.current["IVD_YUSHUTUNYUKBN"]);
                    break;
            }
            fnc.current.postaxios("InvExpense/GetInvoice", { "keys": values },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        let invoiceDate = "";
                        let blNo = "";
                        let tukanbi = "";
                        if (data.rowdata.length > 0) {
                            invoiceDate = data.rowdata[0]["invoiceDate"];
                            blNo = data.rowdata[0]["blNo"];
                            tukanbi = data.rowdata[0]["tukanbi"];
                        }
                        entrydataRef.current = {
                            ...entrydataRef.current,
                            IKD_INVOICEDATE: invoiceDate,
                            IKD_BLNO: blNo,
                            BLD_TUKANBI: tukanbi,
                        };
                        if (edit) fnc.current.entryrerender();
                    },
                    errmsg: "処理に失敗しました"

                }
            )
        }
        if (id === INV_KBN_FIELD && edit) {
            // 輸出入区分が変わったらパネル表示を切り替えるため再描画
            rerender();
        }
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    function RestoreLayout(panels, fields) {
        RestorePanel(panels);
        RestoreBase(fields);
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    function LayoutSaveStorage() {
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id, gridlist[i].type) ? null : GridColApi({ id: gridlist[i].id, type: gridlist[i].type }));
        }
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id, type: panel[p].type }));
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id, panel[p].type);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function () {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    function TotalCalc(data) {
        let total = 0;
        if (isEmpty(data)) return total;
        for (let i = 0; i < data.length; i++) {
            total += NumConv(data[i][TOTAL_TARGET_FIELD]);
        }
        return total;
    }
    function SetTotalData(sourceId, sourceData) {
        // 明細パネル(sourceId)の集計を "T" + sourceId の合計行へ反映
        let total = TotalCalc(sourceData);
        let totalApi = GridApi({ id: "T" + sourceId });
        if (isEmpty(totalApi)) return;
        let rowNode = totalApi.getRowNode("TOTAL");
        if (!isEmpty(rowNode)) {
            rowNode.setDataValue(TOTAL_STORE_FIELD, total);
        }
    }
    function ChangeRowValue(params, paramPanel) {
        SetTotalData(paramPanel.id, GridData(paramPanel));
        storeRowData(G_id.Row);
        if (params.node === null || params.node === undefined) return;
        // let rowidx = params.node.rowIndex;
        if (params.column.colId === "IKDM_TSUKATANI") {
            GetRate([params.data], paramPanel);
            // var values = [];
            // values.push("2");
            // values.push(entrydataRef.current["IKD_INVOICEDATE"]);
            // values.push(params.data["IKDM_TSUKATANI"]);
            // values.push(entrydataRef.current["IVD_YUSHUTUNYUKBN"]);
            // fnc.current.postaxios("InvExpense/GetRate", { "keys": values },
            //     {
            //         onSuccess: function (data) {
            //             fnc.current.wait(false);
            //             var cur = "";
            //             var curNm = "";
            //             var rate = "";
            //             if (data.rowdata.length > 0) {
            //                 cur = "2";
            //                 curNm = "計上レート";
            //                 rate = data.rowdata[0]["rate"];
            //             }
            //             for (let i = 0; i < gridlist.length; i++) {
            //                 if (gridlist[i].id === G_id.PL) continue;
            //                 if (gridlist[i].id != "1") continue;
            //                 var id = yunyuyushutuKbn.current;
            //                 var type = "102";
            //                 if (id === "2") type = "112";
            //                 var rows = GridData({ id: id, type: type });
            //                 // rows[rowidx]["IKDM_CUR"] = cur;
            //                 // rows[rowidx]["IKDM_CUR_NM"] = curNm;
            //                 // rows[rowidx]["IKDM_RATE"] = rate;
            //                 params.node.setDataValue("IKDM_CUR", cur);
            //                 params.node.setDataValue("IKDM_CUR_NM", curNm);
            //                 params.node.setDataValue("IKDM_RATE", rate);
            //                 SetGridData("1", rows);
            //             }
            //             fnc.current.rerenderGrid(panel.id);
            //         },
            //         errmsg: "処理に失敗しました"

            //     }
            // )
        }
        if (params.column.colId === "IKDM_KINGAKUF") {
            var values = [];
            values.push(yunyuyushutuKbn.current);
            values.push("1");                           // 外貨⇒円貨
            // values.push(params.data["IKDM_TSUKATANI"]);
            values.push("JPY");
            values.push(String(params.data["IKDM_RATE"]));      // レート
            values.push(String(params.data["IKDM_KINGAKUF"]));  // 外貨
            fnc.current.postaxios("InvExpense/GetAmount", { "keys": values },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        var amount = 0;
                        if (data.rowdata.length > 0) {
                            amount = data.rowdata[0]["amount"];
                        }
                        for (let i = 0; i < gridlist.length; i++) {
                            if (gridlist[i].id === G_id.PL) continue;
                            if (gridlist[i].id != "1") continue;
                            var id = yunyuyushutuKbn.current;
                            var type = "102";
                            if (id === "2") type = "112";
                            var rows = GridData({ id: id, type: type });
                            params.node.setDataValue("IKDM_KINGAKU", amount);
                            //SetGridData("1", rows);
                            if (params.data["IKDM_KINGAKU"] !== amount) {
                                params.node.setDataValue("IKDM_KINGAKU", amount);
                                SetGridData("1", rows);
                            }
                            //fnc.current.rerenderGrid(gridlist[i].id);
                        }
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
        if (params.column.colId === "IKDM_KINGAKU") {
            if (params.data["IKDM_TSUKATANI"] === "JPY") return;
            var values = [];
            values.push(yunyuyushutuKbn.current);
            values.push("2");                           // 円貨⇒外貨
            values.push(params.data["IKDM_TSUKATANI"]);
            values.push(String(params.data["IKDM_RATE"]));      // レート
            values.push(String(params.data["IKDM_KINGAKU"]));   // 円貨
            fnc.current.postaxios("InvExpense/GetAmount", { "keys": values },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        var amount = 0;
                        if (data.rowdata.length > 0) {
                            amount = data.rowdata[0]["amount"];
                        }
                        for (let i = 0; i < gridlist.length; i++) {
                            if (gridlist[i].id === G_id.PL) continue;
                            if (gridlist[i].id != "1") continue;
                            var id = yunyuyushutuKbn.current;
                            var type = "102";
                            if (id === "2") type = "112";
                            var rows = GridData({ id: id, type: type });
                            if (params.data["IKDM_KINGAKUF"] !== amount) {
                                params.node.setDataValue("IKDM_KINGAKUF", amount);
                                SetGridData("1", rows);
                            }
                            //SetGridData("1", rows);
                        }
                        //fnc.current.rerenderGrid(panel.id);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }

    function RowValueChanged(colid, targets, panel) {
        if (colid === "IKDM_TSUKATANI") {
            GetRate(targets, panel);
        }
    }

    function GetRate(target, panel) {
        var values = [];
        values.push("2");
        values.push(entrydataRef.current["IKD_INVOICEDATE"]);
        values.push(target[0]["IKDM_TSUKATANI"]);
        values.push(entrydataRef.current["IVD_YUSHUTUNYUKBN"]);
        values.push(String(target[0]["IKDM_KINGAKU"]));
        fnc.current.postaxios("InvExpense/GetRate", { "keys": values },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    var cur = "";
                    var curNm = "";
                    var rate = "";
                    if (data.rowdata.length > 0) {
                        cur = "2";
                        curNm = "計上レート";
                        rate = data.rowdata[0]["rate"];
                    }
                    const rows = GridData(panel);
                    if (!Array.isArray(rows) || rows.length === 0) {
                        fnc.current.rerenderGrid(panel.id);
                        return;
                    }
                    const targetRowId = target && target[0] ? target[0].rowid : undefined;
                    let updated = false;
                    if (targetRowId !== undefined) {
                        const idx = rows.findIndex(r => r && r.rowid === targetRowId);
                        if (idx !== -1) {
                            rows[idx]["IKDM_CUR"] = cur;
                            rows[idx]["IKDM_CUR_NM"] = curNm;
                            rows[idx]["IKDM_RATE"] = rate;
                            updated = true;
                            if (rows[idx]["IKDM_TSUKATANI"] === "JPY") {
                                rows[idx]["IKDM_KINGAKUF"] = "";
                            } else {
                                if (data.rowdata[0]?.kingakuf != null) {
                                    rows[idx]["IKDM_KINGAKUF"] = data.rowdata[0].kingakuf;
                                }
                            }
                        }
                    }
                    if (!updated && target && target[0]) {
                        target[0]["IKDM_CUR"] = cur;
                        target[0]["IKDM_CUR_NM"] = curNm;
                        target[0]["IKDM_RATE"] = rate;
                        updated = true;
                    }
                    if (updated) {
                        SetGridData(panel, rows);
                    }
                    // for (let i = 0; i < gridlist.length; i++) {
                    //     if (gridlist[i].id === G_id.PL) continue;
                    //     if (gridlist[i].id != "1") continue;
                    //     var id = yunyuyushutuKbn.current;
                    //     var type = "102";
                    //     if (id === "2") type = "112";
                    //     var rows = GridData({ id: id, type: type });
                    //     // rows[rowidx]["IKDM_CUR"] = cur;
                    //     // rows[rowidx]["IKDM_CUR_NM"] = curNm;
                    //     // rows[rowidx]["IKDM_RATE"] = rate;
                    //     rows["IKDM_CUR"] = cur;
                    //     rows["IKDM_CUR_NM"] = curNm;
                    //     rows["IKDM_RATE"] = rate;
                    //     SetGridData("1", rows);
                    // }
                    fnc.current.rerenderGrid(panel.id);
                },
                errmsg: "処理に失敗しました"

            }
        )
    }

    function RemoveRow(params) {
        var data = GridData({ id: params.id, type: params.type });
        SetTotalData(params.id, data);
    }

    function tabletype(id, type) {
        if (!isEmpty(type)) return type;
        if (id.substr(0, 1) === "T") {
            if (isEmpty(columninfo)) return "";
            let col = columninfo.find(e => e.logpid === id);
            if (isEmpty(col)) return '';
            return col.type;
        } else {
            let pnl = panel.find(e => e.id === id);
            if (isEmpty(pnl)) return '';
            return pnl.type;
        }
    }

    function lockcell(params, defaultEditable, formstatus, panelType) {
        // 通貨単位がJPYの場合、金額（外貨）は入力不可
        if (params.column.colId === "IKDM_KINGAKUF") {
            const control = params.data["IKDM_TSUKATANI"]; // 判定に使うカラム
            if (control === 'JPY') return false; // 編集不可
        }
        return defaultEditable;
    }

    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.name}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.grid) {
            if (props.panel.id !== G_id.PL) {
                const hasTotal = gridlist.some(e => e.id === "T" + props.panel.id);
                return (
                    <React.Fragment>
                        <EntryGridAr
                            id={fnc.current.GridID(props.panel)}
                            entrydataRef={entrydataRef}
                            dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                            columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                            columninfo={columninfo}
                            columns={columns}
                            fnc={fnc}
                            onFirstDataRendered={onFirstDataRendered}
                            ValueChanged={(e) => { ChangeRowValue(e, props.panel); }}
                            RowValueChanged={(colid, rows) => RowValueChanged(colid, rows, props.panel)}
                            RemoveRow={() => { storeRowData(props.panel); RemoveRow(props.panel); }}
                            lockcell={lockcell}
                            formid={formid}
                            panel={props.panel}
                        />
                        {hasTotal ?
                            <EntryGridAr
                                id={fnc.current.GridID("T" + props.panel.id)}
                                entrydataRef={entrydataRef}
                                dataRef={griddataRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columnRef={gridcolRefs.current[fnc.current.gridindex("T" + props.panel.id)]}
                                columninfo={columninfo}
                                columns={columns}
                                fnc={fnc}
                                onFirstDataRendered={onFirstDataRendered}
                                formid={formid}
                                panel={props.panel}
                                total={true}
                                totaltype={tabletype("T" + props.panel.id)}
                            />
                            : null}
                    </React.Fragment>
                );
            } else {
                return (
                    <EntryGridAr
                        id={fnc.current.GridID(props.panel)}
                        entrydataRef={entrydataRef}
                        dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                        columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                        columninfo={columninfo}
                        columns={columns}
                        fnc={fnc}
                        onFirstDataRendered={onFirstDataRendered}
                        formid={formid}
                        ValueChanged={() => storeRowData(props.panel)}
                        panel={props.panel}
                    />
                );
            }
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            );
        }
        return null;
    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true;
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true;
            }
            if (id === G_id.BASE) return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id, type);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (EmptyPanel(p.id, p.type)) return true;
        // Invoice区分によるパネル出し分け(未選択時は輸入=1 にフォールバック)
        let kbn = isEmpty(entrydataRef.current) ? "" : DicVal(entrydataRef.current, INV_KBN_FIELD, "");
        if (isEmpty(kbn)) kbn = "1";
        const allowTypes = PANEL_TYPES_BY_KBN[yunyuyushutuKbn.current];
        // 対応するpanel type 以外は非表示、また対応するidx以外の合計行も非表示
        if (!isEmpty(allowTypes) && allowTypes.indexOf(p.type) === -1) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef}>
                {panel.map((p, i) => {
                    return (
                        <Box
                            key={p.id + "_" + p.type + "_" + i}
                            display={panelhidden(p) ? "none" : "flex"}
                            justifyContent="space-around"
                            alignItems="center"
                            padding="5px"
                        >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                            >
                                <div style={{ position: 'relative', marginBottom: 5 }}>
                                    {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                    {p.id !== '0' || layoutlock ? null :
                                        <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                            <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                                <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                    {layoutlock || sectionclose ? null :
                                        <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                            <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                                <Icon style={{ fontSize: 16 }}>close</Icon>
                                            </IconButton>
                                        </div>
                                    }
                                </div>
                                <Contents panel={p} />
                            </Paper >
                        </Box>
                    );
                })}
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <AGFunc ref={AGRef} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                tabs={true}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                entrycallback={MenuAction}
                usecondition={true}
                entryform={true}
                suppressaction={suppressaction}
                show={Show}
                primarykey={primarykeys}
            >
                <EntryForm />
            </MasterBase>
            <EntryLayout
                columninfo={textfieldsall}
                textfields={textfields}
                onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <div style={{ position: 'absolute', top: 60, left: 210 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0.5,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                        >
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                            />
                        </Paper>
                    </div>
                </div>
                : null}
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
        </div>
    );
};
